<!-- @format -->

<div class="choose-plan">
  <div ngbDropdown #dropdown="ngbDropdown">
    <h2 id="skip-link-target" tabindex="-1">
      <button
        type="button"
        ngbDropdownToggle
        class="non-button choose-plan__button"
        data-cy="choose-study-plan"
        [attr.aria-label]="(selectedPlan$ | async)?.name + ' ' + ('ARIA_LABEL.SELECT_PLAN' | translate)">
        <span class="row d-inline-flex">
          <span class="choose-plan__button__title">
            {{ (selectedPlan$ | async)?.name || ("STUDY_PLANS" | translate) }}
            @if ((selectedPlan$ | async)?.primary) {
              <sis-tiny-badge [variant]="'success'" data-cy="study-plan-primary-badge">
                {{ "PRIMARY_STUDY_PLAN" | translate }}
              </sis-tiny-badge>
            }
          </span>
          <span class="choose-plan__button__icon">
            <sis-icon icon="chevron" iconClass="cw-90"></sis-icon>
          </span>
        </span>
      </button>
    </h2>
    <div ngbDropdownMenu class="multiple-line-items" role="menu">
      @for (option of options$ | async; track option) {
        @if (option.education) {
          <span class="dropdown-header" role="heading">
            {{ option.education.name | localizedString }}
          </span>
        }
        @if (!option.education && option.plan) {
          <button
            ngbDropdownItem
            role="option"
            data-cy="plan-select-button"
            (click)="onSelect(option.id); dropdown.close()"
            [attr.aria-current]="option.id === (selectedPlan$ | async)?.id"
            [class.active]="option.id === (selectedPlan$ | async)?.id">
            {{ option.plan.name }}
            @if (option.id === (selectedPlan$ | async)?.id) {
              <span class="visually-hidden">{{ "ARIA_LABEL.SELECTED" | translate }}</span>
            }
            @if (option.plan.primary) {
              <sis-tiny-badge [variant]="'success'" data-cy="study-plan-primary-badge">
                {{ "PRIMARY_STUDY_PLAN" | translate }}
              </sis-tiny-badge>
            }
            <span class="additional-data">
              @if (option.selectedLearningOpportunityName) {
                <span>{{ option.selectedLearningOpportunityName | localizedString }}, </span>
              }
              {{ option.curriculumPeriodName | localizedString }},
              {{ "STUDY_PLAN_MODIFIED" | translate: { modified: option.plan.metadata.lastModifiedOn | localDateFormat } }}
            </span>
          </button>
        }
      }
    </div>
    @if (selectedPlan$ | async; as selectedPlan) {
      <div class="plan-description">
        {{ selectedPlanEducationName$ | async | localizedString }}
        (
        @if (selectedLearningOpportunityName$ | async; as selectedLearningOpportunityName) {
          {{ selectedLearningOpportunityName | localizedString }},
        }
        @if (selectedPlanCurriculumPeriodName$ | async; as selectedPlanCurriculumPeriodName) {
          {{ selectedPlanCurriculumPeriodName | localizedString }},
        }
        {{
          "STUDY_PLAN_MODIFIED_CREATED"
            | translate
              : {
                  created: selectedPlan.metadata.createdOn | localDateFormat,
                  modified: selectedPlan.metadata.lastModifiedOn | localDateFormat,
                }
        }})
      </div>
    }
  </div>
</div>
